import { useMemo } from 'react';
import { pipe } from 'fp-ts/function';
import { ResourceCategory } from '@mews-commander/data-access';
import { keyById, values } from '@mews/fp';
import { useResourceCategoriesSuspenseQuery } from '../queries/resources';
import { orderOrderableEntityArray } from './orderableEntities';

export const useResourceCategories = (
    resourceCategoryIds: string | string[],
    serviceId?: string
): Record<string, ResourceCategory> => {
    const { data } = useResourceCategoriesSuspenseQuery({ serviceId });

    return useMemo(() => {
        if (!Array.isArray(resourceCategoryIds) || !resourceCategoryIds.length) {
            return keyById(data);
        }

        const filteredData = data?.filter((c) => resourceCategoryIds.includes(c.id));
        return keyById(filteredData);
    }, [data, resourceCategoryIds]);
};

export const useResourceCategory = (id: string, serviceId?: string): ResourceCategory | undefined => {
    const categories = useResourceCategories(id, serviceId);
    return categories[id];
};

export const useResourceCategoriesByServiceId = (serviceId: string) => useResourceCategories([], serviceId);

export const useSortedResourceCategoriesByServiceId = (serviceId: string) => {
    const resourceCategories = useResourceCategories([], serviceId);
    return useMemo(() => pipe(resourceCategories, values, orderOrderableEntityArray), [resourceCategories]);
};
